import axios from 'axios';

// Crear instancia de axios con URL base correcta
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
});

// Log para verificar qué URL base se está utilizando
console.log('API Base URL:', process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000');

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Si el error es 401 (No autorizado)
    if (error.response && error.response.status === 401) {
      // Redirigir a la página de inicio para que el usuario vuelva a iniciar sesión
      window.location.href = '/';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default api;